<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["signup"] }}</p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["enter_your_payment_details"] }}
      </p>
      <input
        type="tel"
        v-mask="'################'"
        v-model="number"
        :placeholder="this.$store.getters.TRANSLATIONS['credit_card_number']"
        class="number"
        autocomplete="off"
      />
      <div class="card-wrapper">
        <input
          type="tel"
          v-mask="'##/##'"
          v-model="expire"
          :placeholder="this.$store.getters.TRANSLATIONS['mm_yy']"
          class="box expire"
          autocomplete="off"
        />
        <input
          type="tel"
          v-mask="'XXXXXX'"
          v-model="cvv"
          :placeholder="this.$store.getters.TRANSLATIONS['cvv']"
          class="box cvv"
          autocomplete="off"
        />
        <input
          v-mask="'XXXXXX'"
          v-model="zip"
          :placeholder="this.$store.getters.TRANSLATIONS['postal_code']"
          class="zip"
          inputmode
          v-uppercase
        />
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="addCard()" class="button next_button">
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
      <button v-on:click="addCardSkip()" class="button skip_button">
        {{ this.$store.getters.TRANSLATIONS["skip"] }}
      </button>
    </div>
    <v-dialog
      style="margin-top: 25%"
      content-class="my-custom-dialog"
      :width="250"
    />
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      loading: false,
      number: "",
      expire: "",
      cvv: "",
      zip: "",
      addCard: () => {
        let error;
        if (!this.validateCardNumber(this.number)) {
          error = this.$store.getters.TRANSLATIONS["no_valid_card_number"];
        }
        if (!this.validateMMDD(this.expire)) {
          error = this.$store.getters.TRANSLATIONS["no_valid_expire_date"];
        }
        if (!this.zip) {
          error = this.$store.getters.TRANSLATIONS["not_valid_zip"];
        }
        if (!this.validateCVV(this.cvv)) {
          error = this.$store.getters.TRANSLATIONS["not_valid_cvv"];
        }
        if (error) {
          this.$modal.show("dialog", {
            text: error,
            buttons: [
              {
                title: "OK"
              }
            ]
          });
        } else {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$http
            .post(
              `${process.env.SERVER_URL}/6BFA0C260A2349D7808802D2ACF218CB`,
              {
                number: this.number,
                expire: this.expire,
                cvv: this.cvv,
                zip: this.zip
              },
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Add card response");
              console.log(response);
              if (
                response.data &&
                response.status &&
                response.data === "OK" &&
                response.status === 200
              ) {
                this.$router.push("/parkendaValet");
              }
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.error
              ) {
                text = error.response.data.error;
              }
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      this.$storage.remove("parkendaToken");
                      this.$router.push("/login");
                    }
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
            });
        }
      },
      addCardSkip: () => {
        this.$router.push("/parkendaValet");
      }
    };
  },
  methods: {
    validateCardNumber: (email) => {
      const re =
        /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
      return re.test(email);
    },
    validateMMDD: (MMDD) => {
      const re = /^(0?[1-9]|1[0-2]){1}\/(0?[1-9]|1[0-9]|2[0-9]|3[0-1]){1}$/;
      return re.test(MMDD);
    },
    validateZip: (zip) => {
      const re = /^[0-9]{5}(?:-[0-9]{4})?$/;
      return re.test(zip);
    },
    validateCVV: (CVV) => {
      const re = /^[0-9]{3,4}$/;
      return re.test(CVV);
    }
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
input {
  float: left;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
input::placeholder {
  color: rgba(114, 174, 255, 1);
}
.number {
  margin: 5vh 17vw 0px;
  width: 65%;
}
.card-wrapper {
  display: inline-flex;
  margin: 4vh 17vw 0 17vw;
  justify-content: space-between;
}
.expire {
  width: 20%;
}
.cvv {
  width: 20%;
}
.zip {
  width: 35%;
}
.text {
  color: #fbae31;
  font-size: 3.5vh;
  font-family: BrandonGrotesqueMedium;
  text-align: left;
  margin-left: 17vw;
  text-decoration: underline;
  text-decoration-color: gray;
  line-height: 0.5;
  text-underline-offset: 10px;
}
.content_title {
  color: #ffffff;
  margin-top: 3.5vh;
  font-size: 1.6vh;
  font-family: BrandonGrotesqueMedium;
  text-align: left;
  margin-left: 17vw;
}
.skip_button {
  background-color: white;
  color: #fbae31;
}
.next_button:disabled {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AddCard.vue